import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import Img from "gatsby-image";
import { Col, Container, Row } from "reactstrap";
import HomeHeroImg from "../../images/home-hero.jpg";

const HomeBanner = () => {
  const data = useStaticQuery(graphql`
    query {
      bannerImg: file(relativePath: { eq: "home-hero.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 800, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  return (
    <div className="wrap-hero-banner">
      <div className="hero-banner">
        <img alt="Home Page Hero Banner" src={HomeHeroImg} />
        {/* <Img
          fluid={data.bannerImg.childImageSharp.fluid}
          loading="eager"
          fadeIn={true}
          alt="Banner Image"
        /> */}
      </div>

      <Container>
        <Row>
          <Col lg={12}>
            <div className="hero-title">
              Unlocking business opportunities with technological innovation{" "}
            </div>
          </Col>
        </Row>

        {/* <Row>
          <Col lg={12}>
            <div className="lbl-set-hero">
              <div className="lbl-hero">For Start Ups/Scale Ups</div>
              <div className="lbl-hero">For Mid-Size Businesses</div>
              <div className="lbl-hero">For Large Enterprise</div>
            </div>
          </Col>
        </Row> */}
      </Container>
    </div>
  );
};

export default HomeBanner;

